import { useCallback, useState } from 'react'

import { GetItemsPriceFilterColumnName } from 'types/gql-global-types'
import { AmountRange } from 'components/AmountRange/AmountRange'

import { useItemManagementContext } from '../ItemManagementContext/ItemManagementContext'

const MAX = 99999
const MIN = 0

interface PriceFilterProps {
  rangeDebounceDuration?: number
}

// NOTE: When time move this component to src/components and handle initial
// values and setting filters via prop callback
export const PriceFilter = ({
  rangeDebounceDuration = 300,
}: PriceFilterProps) => {
  const {
    items: { filterInput, setFilterInput },
  } = useItemManagementContext()

  const [rangeInitialValues] = useState<[number, number]>(() => [
    filterInput?.priceFilter?.from ? filterInput.priceFilter.from / 10000 : MIN,
    filterInput?.priceFilter?.to ? filterInput.priceFilter.to / 10000 : MAX,
  ])

  const handleRangeChange = useCallback(
    (changedRange) => {
      setFilterInput({
        ...filterInput,
        priceFilter: {
          columnName: GetItemsPriceFilterColumnName.price,
          to: changedRange[1] * 10000,
          from: changedRange[0] * 10000,
        },
      })
    },
    [filterInput, setFilterInput]
  )

  return (
    <div data-testid="price-filter-items">
      <AmountRange
        debounceDuration={rangeDebounceDuration}
        initialValues={rangeInitialValues}
        onChange={handleRangeChange}
      />
    </div>
  )
}
